<template>
  <v-container class="privacy-page py-6 py-md-10">
    <v-row justify="center">
      <v-col cols="12" lg="10" xl="9">
        <v-card outlined class="privacy-card">
          <v-sheet color="#6598C1" dark class="pa-6 pa-md-8">
            <div class="d-flex flex-column flex-md-row align-md-center">
              <div>
                <div class="overline mb-2">Protección de datos personales</div>
                <h1 class="privacy-title mb-2">Aviso de Privacidad Integral</h1>
                <div class="subtitle-1">
                  Armando Ricavar Cisneros · Agente autorizado de seguros
                </div>
                <div class="caption mt-3">Última actualización: 23 de julio de 2026</div>
              </div>

              <v-spacer />

              <div class="mt-5 mt-md-0 d-flex flex-wrap justify-md-end">
                <!-- <v-btn
                  :href="pdfUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  outlined
                  dark
                  class="mr-2 mb-2"
                >
                  <v-icon left>mdi-file-pdf-box</v-icon>
                  Ver PDF
                </v-btn>

                <v-btn :href="pdfUrl" download color="white" class="mb-2">
                  <v-icon left color="#477DA8">mdi-download</v-icon>
                  <span class="download-text">Descargar</span>
                </v-btn> -->
              </div>
            </div>
          </v-sheet>

          <v-card-text class="pa-5 pa-md-8 privacy-content">
            <p>
              En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de
              los Particulares y demás disposiciones aplicables,
              <strong>Armando Ricavar Cisneros</strong> pone a disposición de las personas titulares
              el presente Aviso de Privacidad Integral.
            </p>

            <v-alert color="#EAF3F9" border="left" colored-border class="my-7">
              <div class="text-h6 section-title mb-2">
                Identidad y domicilio del responsable
              </div>
              <p class="mb-0">
                <strong>Armando Ricavar Cisneros</strong>, agente de seguros autorizado por la
                Comisión Nacional de Seguros y Fianzas y domicilio en Nicolás Zapata núm. 710,
                colonia Arboleda de Tequisquiapan, C.P. 78235, San Luis Potosí, S.L.P., México, 
                es responsable del tratamiento, uso y protección de los datos personales 
                recabados con motivo de sus actividades de
                asesoría e intermediación de seguros.
              </p>
            </v-alert>

            <section class="privacy-section">
              <h2>1. Datos personales utilizados</h2>
              <p>
                Dependiendo del producto solicitado y de la etapa de la relación con la persona
                titular, el responsable podrá tratar las siguientes categorías de datos:
              </p>

              <v-list dense class="transparent-list">
                <v-list-item v-for="item in personalData" :key="item">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="#6598C1">mdi-circle-small</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="list-text">{{ item }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <h3>Datos personales sensibles relacionados con la salud</h3>
              <p>
                Armando Ricavar Cisneros podrá recabar datos personales sensibles relacionados
                con la salud únicamente cuando sean necesarios para cotizar, solicitar, evaluar,
                contratar, renovar, modificar o administrar seguros de vida, gastos médicos,
                accidentes u otros productos que requieran dicha información, así como para
                brindar orientación o apoyo documental relacionado con reclamaciones y siniestros.
              </p>
              <p>
                Estos datos podrán incluir respuestas a cuestionarios médicos, antecedentes
                declarados, padecimientos, tratamientos, hospitalizaciones, medicamentos,
                estudios, resultados clínicos o documentos solicitados por la institución
                aseguradora. El agente no presta atención médica ni integra un expediente clínico
                propio; la información se utiliza únicamente para las actividades de
                intermediación correspondientes.
              </p>
              <p>
                Cuando resulte exigible, el consentimiento para datos patrimoniales o financieros
                se obtendrá de forma expresa. Para los datos sensibles de salud, se obtendrá el
                consentimiento expreso y por escrito mediante firma autógrafa, firma electrónica
                o un mecanismo electrónico de autenticación. La negativa puede impedir cotizar o
                contratar productos cuya evaluación requiera esa información.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>2. Cookies, web beacons y tecnologías similares</h2>
              <p>
                Cuando se utilicen portales digitales, podrán emplearse cookies, web beacons y
                tecnologías similares para mejorar la experiencia, administrar sesiones y analizar
                el funcionamiento del sitio. Estas herramientas pueden recopilar dirección IP,
                tipo de navegador, páginas visitadas y duración de la visita.
              </p>
              <p>
                La persona usuaria puede deshabilitar estas tecnologías desde la configuración de
                su navegador, aunque algunas funciones del sitio podrían verse afectadas.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>3. Medidas de seguridad y tiempo de conservación</h2>
              <p>
                El responsable mantiene medidas de seguridad administrativas, técnicas y físicas
                razonables para proteger los datos personales contra daño, pérdida, alteración,
                destrucción, uso, acceso o tratamiento no autorizado.
              </p>
              <p>
                Los datos serán conservados durante el tiempo necesario para atender la
                cotización, solicitud, contratación, administración, renovación y seguimiento del
                seguro, y posteriormente durante los plazos legales, contractuales, fiscales,
                regulatorios o de prescripción de responsabilidades que resulten aplicables.
                Cuando dejen de ser necesarios, serán bloqueados y posteriormente eliminados o
                anonimizados, salvo que exista una obligación legal de conservación.
              </p>
              <p>
                Los datos personales sensibles se conservarán únicamente durante el periodo mínimo
                indispensable para cumplir las finalidades informadas y atender las
                responsabilidades derivadas de la intermediación.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>4. Finalidades del tratamiento de datos personales</h2>
              <h3>Finalidades primarias y necesarias</h3>
              <p>
                Los datos personales serán utilizados para las siguientes finalidades necesarias
                relacionadas con las actividades de asesoría e intermediación de seguros:
              </p>

              <v-list dense class="transparent-list">
                <v-list-item v-for="item in primaryPurposes" :key="item">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="#6598C1">mdi-check-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="list-text">{{ item }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <h3>Finalidades secundarias y opcionales</h3>
              <p>
                De manera adicional, los datos de contacto podrán utilizarse para enviar
                información promocional y realizar encuestas de satisfacción. La negativa a estas
                finalidades no afectará la asesoría ni los servicios de intermediación solicitados.
                La persona titular podrá solicitar su exclusión mediante los medios indicados en
                este aviso.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>5. Transferencias de datos personales</h2>
              <p>
                Armando Ricavar Cisneros podrá transferir los datos personales estrictamente
                necesarios a las instituciones de seguros con las que mantenga contratos vigentes
                de intermediación, cuando resulte necesario para elaborar cotizaciones, presentar
                solicitudes, evaluar el riesgo, contratar o emitir pólizas, gestionar renovaciones,
                modificaciones, cancelaciones, pagos o brindar apoyo relacionado con reclamaciones
                y siniestros.
              </p>
              <p>
                La información será transferida únicamente a la institución aseguradora
                correspondiente al producto solicitado o contratado. Una vez recibidos los datos,
                la aseguradora los tratará conforme a su propio aviso de privacidad y a las
                obligaciones legales que le resulten aplicables.
              </p>
              <p>
                También podrán realizarse transferencias cuando sean exigidas por una autoridad
                competente, estén previstas en una disposición legal o resulten necesarias para el
                reconocimiento, ejercicio o defensa de un derecho. Cuando una transferencia
                requiera consentimiento, este será solicitado previamente mediante el mecanismo
                correspondiente.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>6. Derechos de acceso, rectificación, cancelación u oposición (ARCO)</h2>
              <p>
                La persona titular o su representante legal podrá solicitar en cualquier momento
                el acceso, rectificación, cancelación u oposición respecto de sus datos personales.
              </p>

              <v-card outlined class="contact-card mt-5 mb-5">
                <v-card-text>
                  <div><strong>Área responsable:</strong> Atención a clientes</div>
                  <div class="mt-2">
                    <strong>Domicilio:</strong> Nicolás Zapata núm. 710, colonia Arboleda de
                    Tequisquiapan, C.P. 78235, San Luis Potosí, S.L.P.
                  </div>
                  <div class="mt-2"><strong>Teléfono:</strong> 444 813 5480, ext. 113</div>
                  <div class="mt-2">
                    <strong>Correo:</strong>
                    <a href="mailto:atencionclientes@medicover.com.mx">
                      atencionclientes@medicover.com.mx
                    </a>
                  </div>
                </v-card-text>
              </v-card>

              <p>La solicitud deberá contener, por lo menos:</p>
              <ol class="arco-list">
                <li v-for="item in arcoRequirements" :key="item">{{ item }}</li>
              </ol>

              <p class="mt-5">
                El responsable comunicará la determinación adoptada en un plazo máximo de veinte
                días hábiles contado desde la recepción de la solicitud. Si resulta procedente,
                hará efectivo el derecho dentro de los quince días hábiles siguientes. Ambos plazos
                podrán ampliarse una sola vez por un periodo igual cuando las circunstancias del
                caso lo justifiquen.
              </p>
              <p>
                El ejercicio de los derechos ARCO es gratuito; únicamente podrán cobrarse costos
                razonables de reproducción, copias o envío cuando resulten aplicables. La respuesta
                será comunicada por el medio señalado por la persona solicitante, previa
                acreditación de su identidad.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>7. Opciones para limitar el uso o divulgación y revocar el consentimiento</h2>
              <p>
                La persona titular podrá solicitar la revocación del consentimiento para los
                tratamientos que dependan de este, así como limitar el uso o divulgación de sus
                datos personales, mediante el correo
                <a href="mailto:atencionclientes@medicover.com.mx">
                  atencionclientes@medicover.com.mx
                </a>.
                La revocación no tendrá efectos retroactivos y puede no resultar procedente cuando
                el tratamiento sea necesario para cumplir obligaciones legales o contractuales.
              </p>
              <p>
                La respuesta será enviada al correo electrónico proporcionado por la persona
                solicitante en un plazo máximo de veinte días hábiles.
              </p>
            </section>

            <v-divider class="my-7" />

            <section class="privacy-section">
              <h2>8. Cambios al aviso de privacidad</h2>
              <p>
                El presente aviso podrá modificarse por cambios legales, regulatorios, operativos,
                tecnológicos o relacionados con los servicios ofrecidos. La persona titular podrá
                solicitar información sobre la versión vigente y sus modificaciones mediante el
                correo
                <a href="mailto:atencionclientes@medicover.com.mx">
                  atencionclientes@medicover.com.mx
                </a>.
              </p>
            </section>

            <!-- <v-alert color="#EAF3F9" border="left" colored-border class="mt-8 mb-0">
              <div class="font-weight-bold section-title mb-2">Importante</div>
              Armando Ricavar Cisneros actúa como intermediario entre la persona interesada y las
              instituciones aseguradoras. No tiene el carácter de institución aseguradora ni asume
              directamente los riesgos cubiertos por las pólizas.
            </v-alert> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AvisoPrivacidadAgenteCorregidoView",

  props: {
    pdfUrl: {
      type: String,
      default: "/documentos/Aviso_de_Privacidad_Agente_Armando_2026_Corregido.pdf"
    }
  },

  data() {
    return {
      personalData: [
        "Datos de contacto",
        "Datos de identificación",
        "Datos sobre características físicas",
        "Datos de facturación",
        "Datos laborales",
        "Datos académicos",
        "Datos patrimoniales o financieros",
        "Teléfono móvil"
      ],
      primaryPurposes: [
        "Identificar y contactar a prospectos, contratantes, personas aseguradas, beneficiarias, representantes o reclamantes.",
        "Brindar asesoría sobre productos de seguro y obtener la información necesaria para identificar necesidades de aseguramiento.",
        "Solicitar, elaborar, recibir y comparar cotizaciones de una o varias instituciones aseguradoras.",
        "Integrar, revisar y presentar solicitudes, cuestionarios, declaraciones, documentos y demás información requerida por la institución aseguradora.",
        "Apoyar en la contratación y emisión de pólizas, así como en renovaciones, modificaciones, endosos, cancelaciones o aclaraciones, dentro de las facultades del agente.",
        "Dar seguimiento administrativo a primas, pagos, devoluciones, comprobantes y facturación, cuando corresponda.",
        "Brindar orientación y apoyo documental en reclamaciones y siniestros, sin sustituir las decisiones que correspondan a la institución aseguradora.",
        "Mantener comunicación relacionada con la póliza, el servicio solicitado y las obligaciones derivadas de la relación de intermediación.",
        "Cumplir obligaciones legales, regulatorias, fiscales, contractuales y requerimientos de autoridades competentes."
      ],
      arcoRequirements: [
        "Nombre completo de la persona titular y domicilio, correo electrónico u otro medio para recibir notificaciones.",
        "Documentos que acrediten su identidad y, en su caso, la identidad y personalidad de su representante legal.",
        "Descripción clara y precisa de los datos personales respecto de los cuales desea ejercer el derecho, salvo cuando solicite acceso.",
        "Indicación del derecho ARCO que pretende ejercer y la petición concreta.",
        "Cualquier elemento o documento que facilite la localización de los datos.",
        "En solicitudes de rectificación, las modificaciones solicitadas y la documentación que las sustente."
      ]
    };
  }
};
</script>

<style scoped>
.privacy-page {
  background: #f5f7f9;
  min-height: 100%;
}

.privacy-card {
  overflow: hidden;
  border-radius: 12px;
}

.privacy-title {
  font-size: 2rem;
  line-height: 1.15;
  font-weight: 700;
}

.privacy-content {
  color: #37474f;
  font-size: 16px;
  line-height: 1.75;
}

.privacy-section h2,
.section-title {
  color: #477da8;
  font-size: 1.35rem;
  line-height: 1.35;
  font-weight: 700;
}

.privacy-section h3 {
  color: #477da8;
  font-size: 1.08rem;
  line-height: 1.4;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 10px;
}

.transparent-list {
  background: transparent !important;
}

.list-text {
  white-space: normal;
  line-height: 1.5;
  color: #37474f;
}

.contact-card {
  background: #fafcfd;
}

.arco-list {
  padding-left: 24px;
}

.arco-list li {
  margin-bottom: 8px;
}

.download-text {
  color: #477da8;
}

@media (max-width: 600px) {
  .privacy-title {
    font-size: 1.6rem;
  }

  .privacy-content {
    font-size: 15px;
    line-height: 1.65;
  }
}
</style>
